import React from "react"
import SideNav from "components/SideNav"
import styles from "./styles.scss"
import CategoryForm from "components/CategoryForm"
import {
  getCategory,
  selectCategory,
  updateCategory,
} from "data/categories"
import { connect } from "react-redux"
import AdminHeader from "../../components/AdminHeader"

class CategoryEdit extends React.Component {
  constructor(props) {
    super(props)

    const {
      match: {
        params: { id },
      },
    } = props
    id && props.getCategory(id)
  }

  handleSubmit = values => {
    const category = {
      name: values.categoryName,
    }
    const id = this.props.category.id
    this.props.updateCategory(id, category)
  }
  getInitialValues = () => {
    const { category } = this.props
    return {
      categoryName: category.name,
    }
  }
  render() {
    const { category } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <AdminHeader/>
          <div className={styles.categoryFormWrapper}>
            <SideNav type="categories" />
            <div className={styles.categoryForm}>
              <h2>Uppdatera kategori</h2>
              {category && (
                <CategoryForm
                  category={category}
                  submitText="Spara"
                  onSubmit={this.handleSubmit}
                  initialValues={this.getInitialValues()}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  category: selectCategory(state, ownProps),
})

export default connect(
  mapStateToProps,
  {
    getCategory,
    updateCategory,
  }
)(CategoryEdit)



// WEBPACK FOOTER //
// src/pages/Admin/Categories/CategoryEdit/index.jsx